import React from "react";

const About = () => {
  return (
    <div className="section">
      <div className="about" id="about">
        <h1 className="heading">
          <span>A</span>
          <span>B</span>
          <span>O</span>
          <span>U</span>
          <span>T</span>
        </h1>
        <p>
          Travelling is a little adventure where you get memories and
          experiences of a liftime. To travel is to live. You will always be
          fascinated by the beauty of this world and pondered with the question
          "where to next". But you need not worry about this because with our
          assistance and guidance you can easily figure out where you would like
          to go. We constantly work to amuse you and find a way for you to
          relax. We are here for you!
        </p>
      </div>
    </div>
  );
};

export default About;
